import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const fetchPriceTemplatesRoute = () =>
  buildUrl({
    url: [baseUrl, "prices-loader-api", "templates"].join("/"),
  });

export const createPriceImportRoute = () =>
  buildUrl({
    url: [baseUrl, "prices-loader-api", "imports"].join("/"),
  });

export const checkPriceImportStatusRoute = (importId: number) =>
  buildUrl({
    url: [baseUrl, "prices-loader-api", "imports", importId, "statuses"].join("/"),
  });

export const checkActiveImportRoute = (agreementId: number) =>
  buildUrl({
    url: [baseUrl, "prices-loader-api", "imports", "active-imports"].join("/"),
    searchParams: { agreementId },
  });

export const deletePriceImportRoute = (importId: number) =>
  buildUrl({
    url: [baseUrl, "prices-loader-api", "imports", importId].join("/"),
  });

export const getPriceValidationResultRoute = (searchParams: {
  importId: number;
  page: number;
  size: number;
  closedDestination: boolean;
}) =>
  buildUrl({
    url: [baseUrl, "prices-loader-api", "items"].join("/"),
    searchParams,
  });

export const savePriceImportRoute = (importId: number) =>
  buildUrl({
    url: [baseUrl, "prices-loader-api", "imports", importId, "process"].join("/"),
  });
